import { useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useMagnetic } from '../hooks/useMagnetic.js';

/**
 * Anchor or router Link with a magnetic hover effect.
 *  - `to`: router Link target. Omit to render a plain <a href>.
 *  - `nav`: when true, use NavLink (so `isActive` works) and forward `end` only there.
 *  - `viewTransition`: enables the Router's view-transition wrapper on click.
 */
export function MagneticLink({
  to,
  href,
  className,
  children,
  ariaLabel,
  nav = false,
  viewTransition,
  ...rest
}) {
  const ref = useRef(null);
  useMagnetic(ref);

  if (to) {
    if (nav) {
      return (
        <NavLink
          ref={ref}
          to={to}
          end={to === '/'}
          className={className}
          aria-label={ariaLabel}
          {...(viewTransition ? { viewTransition: true } : {})}
          {...rest}
        >
          {children}
        </NavLink>
      );
    }
    return (
      <Link
        ref={ref}
        to={to}
        className={className}
        aria-label={ariaLabel}
        {...(viewTransition ? { viewTransition: true } : {})}
        {...rest}
      >
        {children}
      </Link>
    );
  }

  return (
    <a ref={ref} href={href} className={className} aria-label={ariaLabel} {...rest}>
      {children}
    </a>
  );
}
